import { DEFAULT_FORMATTER_LOCALE } from '../../constants/defaultFormatterLocale'
import { getFormatLocale } from '../getFormatLocale'

export const getFormattedNumber = (value: number, locale?: string, options?: Intl.NumberFormatOptions) => {
  return new Intl.NumberFormat(getFormatLocale(locale || DEFAULT_FORMATTER_LOCALE), options).format(value)
}
